<script lang="ts">
    import { TextInput } from "carbon-components-svelte";
    import { Button as CarbonButton, ButtonSet } from "carbon-components-svelte";
    import TrashCan32 from "carbon-icons-svelte/lib/TrashCan32";
    import Save32 from "carbon-icons-svelte/lib/Save32";
    import { MultiSelect } from "carbon-components-svelte";
    import { PasswordInput } from "carbon-components-svelte";
    
    import type { Streamer } from './jmdb'
    import { diffArray, deep_copy, newId, streamer_list, streamer_groups, diffDict } from './jmdb';

    import stringify from 'fast-json-stable-stringify'

import { onDestroy } from 'svelte';

    export let streamer : Streamer
    let in_flight = false
    
    let newPassword = ''

    let oldStreamer: Streamer = deep_copy(streamer)
    let dirty = false
    let rightsDirty = false

    let memberOf : string[] = []
    let oldMemberOf: string[] = []

    onDestroy(streamer_groups.subscribe((val) => {
        if (!val.ready) {
            return
        }
        if (memberOf.length != 0) {
            return
        }
        memberOf = []
        for (let gidx in val.data) {
            let g = val.data[gidx]
            if (g.streamers.indexOf(streamer.id) != -1) {
                memberOf.push(g.id.toString())
            }
        }
        memberOf = memberOf
        oldMemberOf = memberOf.slice()
    }))

    $: membersDirty = stringify(memberOf) != stringify(oldMemberOf)
    $: dirty = (stringify(oldStreamer) != stringify(streamer)) || rightsDirty || newPassword != ''
    
    let refetchRelevant = function(): Promise<any> {
        return Promise.all([
            streamer_list.fetch(),
            streamer_groups.fetch(),
        ])
    }

    let after_changes = (res: Response) => {
        if (!res.ok) {
            res.text().then((txt) => {
                window.alert(txt)
            })
            in_flight = false
        } else {
            streamer_groups.invalidate()
            streamer_list.invalidate()
            refetchRelevant().then(()=>{
                in_flight = false
            })
        }
    }
    let saveClicked = () => {
        let old = oldStreamer
        let memberChanges = diffArray(oldMemberOf.map(v=>Number(v)), memberOf.map(v=>Number(v)), (v)=>v, false)

        let changeBundle: any = {
            memberChanges: memberChanges,
            newPassword: newPassword,
        }
        const matchedFields = ["name", "sid"]
        matchedFields.forEach(el => {
            if ((old as any)[el] != (streamer as any)[el]) {
                changeBundle[el] = (streamer as any)[el]
            }
        })
        fetch("/api/v1/streamers/"+streamer.id, {
            'method': 'POST',
            'body': JSON.stringify(changeBundle)
        }).then(after_changes)
        in_flight = true
    }

    let deleteClicked = (e: Event) => {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete "+streamer.name+"?")) {
            fetch("/api/v1/streamers/"+streamer.id, {
                'method': 'DELETE',
                'body': JSON.stringify({})
            }).then(after_changes)
        }
    }
    refetchRelevant()

</script>

    <TextInput bind:value={streamer.name} labelText="Name" placeholder="Enter streamer's display name"/>
    <TextInput bind:value={streamer.sid} labelText="Login" placeholder="Enter streamer's login name"/>
    <PasswordInput bind:value={newPassword} labelText="Change password" placeholder="To change the password, enter a new password here"/>

    {#if $streamer_groups.ready}
    <MultiSelect 
        titleText="Member of:"
        label={memberOf.map(v => $streamer_groups.data.find(ag => ag.id.toString() == v) || {'name': "Not found"}).map(ag=>ag.name).join(', ') || "No streamer groups"}
        items={$streamer_groups.data.map(v => { return {id: v.id.toString(), val: v.id, text: v.name}})}
        bind:selectedIds={memberOf}
        />
        

    {/if}

    <TextInput disabled labelText="NATS PubKey" value={streamer.nid} />


    <ButtonSet stacked style="float: right;">
        <CarbonButton kind="primary" icon={Save32} disabled={!dirty || in_flight} on:click={saveClicked}>Save</CarbonButton>
        {#if streamer.id != newId}
        <CarbonButton kind="danger-ghost" icon={TrashCan32} tooltipPosition="left" on:click={deleteClicked}>Delete</CarbonButton>
        {/if}
    </ButtonSet>
